import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryRecord} from "@/service/record.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";

export const ViewRecord = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: recordData, isLoading: recordLoading} = useQueryRecord({id: drawerId!}, isNumber(drawerId))
    const record = recordData?.data
    return <> <ResultWrapper isLoading={recordLoading} isEmpty={isEmpty(record)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'客户名称'} content={record?.customerName}/>
                <GridItem title={'跟进人'} content={record?.creator}/>
                <GridItem title={'记录内容'} minHeight={"48px"} size={12} content={record?.content}/>
                <GridItem title={'跟进方式'} content={record?.way}/>
                <GridItem title={'跟进内容'} content={record?.type}/>
                <GridItem title={'更新时间'} content={formatTime("D", record?.updatedAt)}/>
                <GridItem title={'跟进时间'} content={formatTime("D", record?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}